export default __webpack_public_path__ + "static/media/WS.a5bc5f08.svg";